module.exports = __webpack_public_path__ + "img/drafting-compass.5f2745d1.svg";